import React, {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import * as RouterActions from '../../../actions/RouterActions';
import { Table, Label } from 'semantic-ui-react'
import * as STATUS_TO_COLOR from '../../../constants/StatusToColor'

var moment = require('moment');
require('moment/locale/de');

export function EventRow(props){
    const dispatch = useDispatch();
    const sport = useSelector(({canvas_structure}) => (typeof canvas_structure.sport[props.event['sport-uid']] !== 'undefined')?canvas_structure.sport[props.event['sport-uid']]:null);
    const category = useSelector(({canvas_structure}) => (typeof canvas_structure.category[props.event['category-uid']] !== 'undefined')?canvas_structure.category[props.event['category-uid']]:null);
    const tournament = useSelector(({canvas_structure}) => (typeof canvas_structure.tournament[props.event['tournament-uid']] !== 'undefined')?canvas_structure.tournament[props.event['tournament-uid']]:null);

    return (
        <Table.Row>
            <Table.Cell>{moment(props.event['active-to'].toDate()).format('DD.MM.YYYY HH:mm')}</Table.Cell>
            <Table.Cell><Label color='blue'>{props.event['playing-numbers'].plus}</Label></Table.Cell>
            <Table.Cell>{(props.event['playing-numbers'].kompakt !== null)?<Label color='green'>{props.event['playing-numbers'].kompakt}</Label>:null}</Table.Cell>
            <Table.Cell>
                <div style={{
                    display: 'inline-block',
                    borderRadius: '5px',
                    color: '#000000',
                    padding: '3px 5px',
                    textAlign: 'center',
                    backgroundColor: (typeof STATUS_TO_COLOR[props.event.status] !== 'undefined')?STATUS_TO_COLOR[props.event.status]:'#FFFFFF'
                }}>
                    {props.event.status}
                </div>
            </Table.Cell>
            <Table.Cell>{
                (sport === null)
                    ?null
                    :(typeof sport.name !== 'undefined')
                        ?sport.name
                        :(typeof sport.canvas !== 'undefined' && typeof sport.canvas.name !== 'undefined')
                            ?sport.canvas.name
                            :(typeof sport.canvas.canvas !== 'undefined')
                                ?sport.canvas.canvas.name
                                :null
            }</Table.Cell>
            <Table.Cell>{
                (category === null)
                    ?null
                    :(typeof category.name !== 'undefined')
                        ?category.name
                        :(typeof category.canvas !== 'undefined' && typeof category.canvas.name !== 'undefined')
                            ?category.canvas.name
                            :(typeof category.canvas.canvas !== 'undefined')
                                ?category.canvas.canvas.name
                                :null
            }</Table.Cell>
            <Table.Cell>{
                (tournament === null)
                    ?null
                    :(typeof tournament.name !== 'undefined')
                        ?tournament.name
                        :(typeof tournament.canvas !== 'undefined' && typeof tournament.canvas.name !== 'undefined')
                            ?tournament.canvas.name
                            :(typeof tournament.canvas.canvas !== 'undefined')
                                ?tournament.canvas.canvas.name
                                :null
            }</Table.Cell>
            <Table.Cell><a style={{cursor: 'pointer'}} onClick={props.onClick}>{props.event.name}</a></Table.Cell>
        </Table.Row>
    )
}